import { mailApiGet, mailApiPost } from "./client";
import type { MailSendPayload } from "@/lib/types/compose";

export type MailScheduledSendEntry = {
  id: number;
  accountId: number;
  sendAt: string;
  status: "pending" | "sent" | "failed" | "cancelled";
  subject: string;
  error?: string | null;
  createdAt?: string | null;
  payload?: MailSendPayload & { toRaw?: string };
};

export type ScheduledSendListResponse = {
  success: boolean;
  accountId?: number | null;
  scheduled: MailScheduledSendEntry[];
};

export function fetchMailScheduledSends(params: { accountId: number }) {
  const qs = new URLSearchParams();
  qs.set("accountId", String(params.accountId));
  return mailApiGet<ScheduledSendListResponse>(`imap/scheduled-send.php?${qs.toString()}`);
}

export function scheduleMailSend(
  payload: MailSendPayload & { accountId: number; sendAt: string }
) {
  return mailApiPost<{ success: boolean; scheduled: MailScheduledSendEntry }>(
    "imap/scheduled-send.php",
    payload,
    { timeoutMs: 120_000 }
  );
}

export function processMailScheduledDue(params: { accountId: number }) {
  return mailApiPost<{
    success: boolean;
    processed: number;
    sent: number;
    errors: number;
  }>(
    "imap/scheduled-send.php",
    {
      accountId: params.accountId,
      processDue: true,
    },
    { timeoutMs: 45_000 }
  );
}

export function cancelMailScheduledSend(params: { accountId: number; id: number }) {
  return mailApiPost<{ success: boolean; id: number; cancelled: boolean }>(
    "imap/scheduled-send.php",
    {
      accountId: params.accountId,
      id: params.id,
      cancel: true,
    }
  );
}

export function sendMailScheduledNow(params: { accountId: number; id: number }) {
  return mailApiPost<{ success: boolean; id: number; sendNow: boolean }>(
    "imap/scheduled-send.php",
    {
      accountId: params.accountId,
      id: params.id,
      sendNow: true,
    },
    { timeoutMs: 120_000 }
  );
}

export function fetchMailScheduledSendDetail(params: { accountId: number; id: number }) {
  const qs = new URLSearchParams();
  qs.set("accountId", String(params.accountId));
  qs.set("id", String(params.id));
  return mailApiGet<{ success: boolean; scheduled: MailScheduledSendEntry }>(
    `imap/scheduled-send.php?${qs.toString()}`
  );
}
